import React from "react";
import "./InRead.css";
import { RandomTime } from "../../../components/smiWidgets/RandomTime";
import { useVisibilityTracker } from "../../../utils/visibilityTracker";

export function InRead({ jsonData, objectId, showId }) {
    if (!jsonData) {
        return null;
    }

    return (
        <div className="in-read">
            {jsonData.map((item) => {
                const visibilityRef = useVisibilityTracker(
                    item.id,
                    objectId,
                    "InRead",
                    jsonData.length,
                    showId,
                    item.cid,
                    item.crid,
                    item.bidder_id,
                    item.bidder_cid,
                    item.eventtrackers,
                    item
                );
                return (
                    <a key={item.id} href={item.url} target="_blank" ref={visibilityRef}>
                        <div className="in-read-block">
                            <img src={item.img} alt={item.title} />
                            <div className="in-read-title">
                                <h2>{item.title}</h2>
                                <RandomTime />
                            </div>
                        </div>
                    </a>
                );
            })}
        </div>
    );
}
